import * as React from 'react'
import { Box } from '@mui/material'
import { formatPercentage } from "@ui-seeker/utils"

import { NotAllowedBlock, ArrowBackground } from '@components'
import { sortByAbsoluteValue } from '../../sort'


export default function diffColumn(label) {
	return {
		name: 'diff', label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency, myPrice, diff }) => {
				return <Box sx={{ textAlign: 'center '}}>
					{!!value && !!myPrice && <ArrowBackground
						value={value}
						backgroundColor={value > 0 ? 'success.light' : 'error.light'}
					>
						{formatPercentage(value, { decimals: 2 })}
					</ArrowBackground>}

					{(!value && !myPrice || !diff) && <NotAllowedBlock />}
				</Box>
			},
			sortCompare: sortByAbsoluteValue
		}
	}
}